import { getRuntimeConfig } from './runtime-config'

export const AI_CONFIG = {
  // Dev: '' (same-origin) so aiAxios hits the relative /hosts, /warmup and
  // /natural_language_query paths, which vite.config.ts proxies to the AI service —
  // this sidesteps the browser CORS check locally. Production talks to the AI service
  // directly, so that service must send the appropriate CORS headers. The origin comes
  // from the backend at runtime (an accessor so it is read after bootstrap, not at
  // module load — services are constructed inside composables, well after mount).
  get apiUrl(): string {
    return import.meta.env.DEV ? '' : getRuntimeConfig().aiSearchApiUrl
  },
  searchEndpoint: '/natural_language_query/webapp_search',
  tokenCacheKey: 'ai_token',
  tokenExpiryCacheKey: 'ai_token_expiry_ms',
  tokenEarlyRefreshMs: 2 * 60 * 1000,
  defaultTokenTtlMs: 55 * 60 * 1000,
  apiTimeoutMs: 30_000,
  lookAlikeHostDetailsEndpoint: '/hosts/details',
  lookAlikeKeyphrasesEndpoint: '/hosts/keyphrases',
  lookAlikeAdvancedSearchEndpoint: '/hosts/advancedsearch',
  lookAlikeWarmupEndpoint: '/warmup',
} as const

/**
 * localStorage key for the persisted AI assistant panel store
 * (`useAiPanelStore` — open state, width, screen→session map).
 * Lives here (shared config) so auth.store can clear it on logout
 * without importing from the aiassistant feature.
 */
export const AI_PANEL_STORAGE_KEY = 'tami_ai_panel'
